<template>
  <div class="bb-transfers-list">
    <Table :options="options" :modal-mode="true"/>
  </div>
</template>

<script>
import FundsTransferApi from '@/api/FundsTransfer/api'
import Table from '@/components/Main/Table/Table'
import {fundsTransfersTable, fundsTransfersTableColumns} from '@/constants/TablesOptions/fundsTransfers'
import _ from 'lodash'

export default {
  name: 'FundTransfersList',
  components: {
    Table
  },
  data () {
    return {
      options: fundsTransfersTable
    }
  },
  computed: {
    fundsList () {
      return this.$store.getters.fundsRowsData
    },
    fundsTransfersColumnsData: {
      get: function () {
        return this.$store.getters.fundsTransfersColumnsData
      },
      set: function (data) {
        this.$store.dispatch('setFundsTransfersColumnsData', data)
      }
    },
    fundsTransfersRowsData: {
      get: function () {
        return this.$store.getters.fundsTransfersRowsData
      },
      set: function (data) {
        this.$store.dispatch('setFundsTransfersRowsData', data)
      }
    }
  },
  methods: {
    getNameFund (id) {
      const fund = _.find(this.fundsList, {id: id})
      return fund ? fund.name : '<i class="bb-table-body__item_gray">deleted</i>'
    },
    getTransfers () {
      FundsTransferApi.getTransfers()
        .then((resp) => {
          this.fundsTransfersRowsData = resp.data.transferFundsState
          this.fundsTransfersRowsData.forEach(item => {
            const idSource = item.sourceFund
            const idDestination = item.destinationFund
            item.sourceFund = this.getNameFund(idSource)
            item.destinationFund = this.getNameFund(idDestination)
          })
        })
        .catch((err) => {
          console.error(err)
        })
    }
  },
  beforeMount () {
    this.getTransfers()
    this.fundsTransfersColumnsData = fundsTransfersTableColumns
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bb-transfers-list {
    margin-right: -8px;
    margin-left: -1px;
    padding: 5px;
    max-width: 50vw;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Finance/Funds/TransfersList/TransfersList.vue